import React, { Component, Fragment } from 'react';
import styles from './StreamingPlayer.module.css';
import Button from '../Button';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import ReactSelect from 'react-select';
import ConfigPanel from '../ConfigPanel';
import Checkbox from 'rc-checkbox';
import Switch from 'react-switch';
import Modal from 'react-modal';

const imgQuality = [
  { title: '1K', note: '( 1000px x 1000px @300dpi )', value: 1000 },
  { title: '2K', note: '( 2000px x 2000px @300dpi )', value: 2000 },
  { title: '4K', note: '( 4000px x 4000px @300dpi )', value: 4000 },
  { title: '8K', note: '( 8000px x 8000px @300dpi )', value: 8000 },
];

const DEFAULT_THUMBNAIL =
  'https://s3.ca-central-1.amazonaws.com/exocortex-crateandbarrel/thumbnail.jpg';

const customStyles = {
  content: {
    top: '35%',
    left: '50%',
    width: '500px',
    right: 'auto',
    bottom: 'auto',
    border: '1px solid grey',
    padding: '20px',
    borderRadius: 0,
    transform: 'translate(-50%, -50%)',
  },
};

const playerEl = document.createElement('div');
playerEl.id = 'streamingEl';
// playerEl.className = styles.player;

export default class StreamingPlayer extends Component {
  state = {
    selectedIndex: 0,
    showError: false,
    selectModel: null,
    productSelect: null,
    modelSelect: null,
    quality: null,
    filename: null,
    products: [],
    models: [],
    activeConfig: 'item1',
    item1: {
      selected: {},
      options: [],
      materials: [],
      rules: [
        {
          name: '',
          values: [],
        },
      ],
    },
    item2: {
      selected: {},
      options: [],
      materials: [],
      rules: [
        {
          name: '',
          values: [],
        },
      ],
    },
    item3: {
      selected: {},
      options: [],
      materials: [],
      rules: [
        {
          name: '',
          values: [],
        },
      ],
    },
    renderMsg: null,
  };

  async componentDidMount() {
    const { fetchProducts, fetchMaterials } = this.props;
    let width = document.getElementById('streamingParent');
    playerEl.setAttribute(
      'style',
      `width:${(width.clientWidth - 10) / 2}px;height:${(width.clientWidth -
        10) /
        2}px;outline:1px solid #000;`
    );
    this.refs['playerParent'].appendChild(playerEl);
    const { item1, item2, item3 } = this.state;
    const products = await fetchProducts();
    const materials = await fetchMaterials({ limit: 1000 });
    let materialOptions = [];
    for (let i in materials) {
      materialOptions.push({
        label: materials[i].friendlyName,
        value: materials[i]['metadata']['File Name'],
      });
    }
    item1.materials = materialOptions;
    item2.materials = materialOptions;
    item3.materials = materialOptions;

    this.setState({
      products: products.length ? products : Object.values(products),
      item1,
      item2,
      item3,
    });
  }

  onSelect = idx => {
    this.setState({ selectedIndex: idx, renderMsg: null });
  };

  componentWillReceiveProps(props) {
    const { streamingError } = this.props;
    if (props.streamingError !== streamingError && props.streamingError) {
      this.setState({ showError: true });
    }
  }

  componentWillUnmount() {
    const { exitVray } = this.props;
    exitVray();
  }

  setCamera(value) {
    const api = window.api;
    if (!api) return;
    const cameraId = api.scene.find(value);
    api.player.setCamera(cameraId);
    api.player.updateVrayTranslator();
    this.setState({ activeCamera: value });
  }

  async changeModelId(data, item) {
    const selectedItem = this.state[item];
    if (selectedItem.selected.sceneId === data && data.value) return;
    const { changeModel } = this.props;
    const modelId = await changeModel(
      selectedItem.selected.modelId,
      data && data.value
    );
    selectedItem.selected = { sceneId: data && data.value, modelId };
    this.setState({ [item]: selectedItem });
  }

  setProduct = (data, item) => {
    this.setState({ [item]: data });
  };

  updateProduct = data => {
    const { activeConfig } = this.state;
    const item = this.state[activeConfig];
    this.updateRender(item);
  };

  updateRender = async item => {
    const { selected, rules } = item;
    if (!selected || !selected.modelId) return;
    const { applyConfigs } = this.props;
    applyConfigs(rules, selected.modelId);
  };

  selectQuality = e => {
    const quality = e.target.id;
    this.setState({ quality });
  };

  selectModel = item => {
    this.setState({ selectModel: item });
  };

  loadProduct = async data => {
    const { fetchModels } = this.props;
    const tags = data && data.value;
    if (data) {
      const models = await fetchModels({ limit: 1000, tags });
      this.setState({ models, productSelect: data && data.value });
    } else {
      this.setState({ productSelect: null });
    }
  };

  addModelToScene = async () => {
    const { selectModel, modelSelect } = this.state;
    if (!selectModel || !modelSelect) return;
    const item = this.state[selectModel];
    item.options.push(modelSelect);
    item.selected.sceneId = modelSelect && modelSelect.value;
    await this.changeModelId(modelSelect, selectModel);
    this.setState({
      [selectModel]: item,
      productSelect: null,
      selectModel: null,
      modelSelect: null,
    });
  };

  closeModal = e => {
    this.setState({ showError: false });
  };

  toggleStart = (checked, item) => {
    const { exitVray, enterVray } = this.props;
    if (!checked) {
      exitVray();
    } else {
      enterVray(item);
    }
  };

  savePublished = async () => {
    const { savePublished, item, createJob } = this.props;
    const { quality, filename } = this.state;
    if (!quality || !filename) return;
    const publishedHash = await savePublished();
    const name = item.friendlyName;
    const asset = item.assets.slice(-1).pop();
    const sceneId =
      (asset && asset.sceneId) || '8449e924-7311-4b75-9fef-3619a48bd748';
    const jobAttr = {
      name: 'Hero Shot ' + name,
      type: 'heroShot',
      filename,
      sceneId,
      publishedHash,
      cameraId: window.api.player.getCamera(), //FIX ME
      width: quality,
      height: quality,
    };
    await createJob(jobAttr);
    this.setState({ renderMsg: 'Shot created ' });
  };

  changeStreamingMode(value) {
    const { setStreamingMode } = this.props;
    setStreamingMode(value);
  }

  render() {
    const {
      streaming,
      item,
      moveModel,
      rotateModel,
      cameraOperation,
    } = this.props;
    const {
      activeCamera,
      activeConfig,
      item1,
      item2,
      item3,
      quality,
      selectModel,
      products,
      models,
      productSelect,
      modelSelect,
      showError,
      selectedIndex,
      renderMsg,
    } = this.state;
    const activeItem = this.state[activeConfig];
    let width = document.getElementById('streamingParent');
    if (width) {
      width = width.clientWidth - 10;
    }
    const cameras = [
      {
        thumbnail: DEFAULT_THUMBNAIL,
        value: item.friendlyName && item.friendlyName.replace(/\s/g, '_'),
      },
      {
        thumbnail: DEFAULT_THUMBNAIL,
        value: 'Camera1',
      },
      {
        thumbnail: DEFAULT_THUMBNAIL,
        value: 'Camera2',
      },
    ];

    return (
      <Fragment>
        <div
          id="streamingParent"
          ref="streamingParent"
          className={styles.streamingParent}
        >
          <div>
            <div className={styles.playerTitle}> Scene </div>
            <img
              style={{
                display: 'block',
                width: width / 2,
                height: width / 2,
              }}
              src={item.thumbnail || DEFAULT_THUMBNAIL}
              id="vrayImg"
            />
            <div className={styles.cameraControl}>
              <div
                className={styles.playerTitle}
                style={{ paddingTop: 15, paddingLeft: 10 }}
              >
                {' '}
                Camera Adjust{' '}
              </div>
              <div
                style={{
                  display: 'flex',
                  width: '90%',
                  margin: 'auto',
                  justifyContent: 'space-between',
                }}
              >
                <div>
                  <div className={styles.controlHeader}> Height </div>
                  <div style={{ display: 'flex' }}>
                    <img
                      onClick={e =>
                        cameraOperation(activeCamera, 'translation', 0, 2)
                      }
                      className={styles.controlImg}
                      src="/img/arrow-up.png"
                    />{' '}
                    <img
                      onClick={e =>
                        cameraOperation(activeCamera, 'translation', 0, -2)
                      }
                      className={styles.controlImg}
                      src="/img/arrow-down.png"
                    />
                  </div>
                </div>
                <div>
                  <div className={styles.controlHeader}> Left/Right </div>
                  <div style={{ display: 'flex' }}>
                    <img
                      onClick={e =>
                        cameraOperation(activeCamera, 'rotation', 0, 2)
                      }
                      className={styles.controlImg}
                      src="/img/arrow-left.png"
                    />{' '}
                    <img
                      onClick={e =>
                        cameraOperation(activeCamera, 'rotation', 0, -2)
                      }
                      className={styles.controlImg}
                      src="/img/arrow-right.png"
                    />
                  </div>
                </div>
                <div>
                  <div className={styles.controlHeader}> Pan </div>
                  <div style={{ display: 'flex' }}>
                    <img
                      onClick={e =>
                        cameraOperation(activeCamera, 'translation', 0, 0, 2)
                      }
                      className={styles.controlImg}
                      src="/img/arrow-left.png"
                    />{' '}
                    <img
                      onClick={e =>
                        cameraOperation(activeCamera, 'translation', 0, 0, -2)
                      }
                      className={styles.controlImg}
                      src="/img/arrow-right.png"
                    />
                  </div>{' '}
                </div>
                <div>
                  <div className={styles.controlHeader}> Tilt </div>
                  <div style={{ display: 'flex' }}>
                    <img
                      onClick={e =>
                        cameraOperation(activeCamera, 'rotation', 2, 0)
                      }
                      className={styles.controlImg}
                      src="/img/arrow-up.png"
                    />{' '}
                    <img
                      onClick={e =>
                        cameraOperation(activeCamera, 'rotation', -2, 0)
                      }
                      className={styles.controlImg}
                      src="/img/arrow-down.png"
                    />
                  </div>{' '}
                </div>
                <div>
                  <div className={styles.controlHeader}> Zoom </div>
                  <div style={{ display: 'flex' }}>
                    <img
                      className={styles.controlImg}
                      src="/img/plus2.png"
                      onClick={e =>
                        cameraOperation(activeCamera, 'translation', -2, 0)
                      }
                    />{' '}
                    <img
                      className={styles.controlImg}
                      src="/img/minus.png"
                      onClick={e =>
                        cameraOperation(activeCamera, 'translation', 2, 0)
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className={styles.playerTitle}> Model Positioning</div>
            <div ref="playerParent" />
            <div className={styles.cameraControl}>
              <div
                className={styles.playerTitle}
                style={{ paddingTop: 15, paddingLeft: 10 }}
              >
                {' '}
                Product Adjust{' '}
              </div>
              <div
                style={{
                  display: 'flex',
                  width: '90%',
                  margin: 'auto',
                  justifyContent: 'space-around',
                }}
              >
                <div>
                  <div className={styles.controlHeader}> Left/Right </div>
                  <div style={{ display: 'flex' }}>
                    <img
                      onClick={e => moveModel(0, 2)}
                      className={styles.controlImg}
                      src="/img/arrow-left.png"
                    />{' '}
                    <img
                      onClick={e => moveModel(0, -2)}
                      className={styles.controlImg}
                      src="/img/arrow-right.png"
                    />
                  </div>{' '}
                </div>
                <div>
                  <div className={styles.controlHeader}> Fwd/Back </div>
                  <div style={{ display: 'flex' }}>
                    <img
                      onClick={e => moveModel(2, 0)}
                      className={styles.controlImg}
                      src="/img/arrow-up.png"
                    />{' '}
                    <img
                      onClick={e => moveModel(-2, 0)}
                      className={styles.controlImg}
                      src="/img/arrow-down.png"
                    />
                  </div>{' '}
                </div>
                <div>
                  <div className={styles.controlHeader}>
                    {' '}
                    Rotate(Left/Right){' '}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <img
                      onClick={e => rotateModel(-2)}
                      className={styles.controlImg}
                      src="/img/arrow-left.png"
                    />{' '}
                    <img
                      onClick={e => rotateModel(2)}
                      className={styles.controlImg}
                      src="/img/arrow-right.png"
                    />
                  </div>{' '}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.content}>
          <Tabs onSelect={this.onSelect} selectedIndex={selectedIndex}>
            <TabList style={{ margin: 0 }}>
              {['Camera Views', 'Products', 'Configuration', 'Render'].map(
                (v, k) => (
                  <Tab
                    style={{
                      background: selectedIndex === k ? '#f2f2f2' : '#fff',
                      width: 150,
                      height: 40,
                      textAlign: 'center',
                      borderRadius: 0,
                    }}
                  >
                    <span className={styles.tabTitle}>{v}</span>
                  </Tab>
                )
              )}
              <div className={styles.toggleContainer}>
                <div className={styles.toggleLabel}>Live Preview</div>
                <Switch
                  width={80}
                  onColor="#6495ed"
                  uncheckedIcon={<div className={styles.toggleIcon}>OFF </div>}
                  checkedIcon={<div className={styles.toggleIcon}>ON</div>}
                  onChange={checked => this.toggleStart(checked, item)}
                  checked={streaming}
                />
              </div>
            </TabList>
            <TabPanel style={{ background: '#f2f2f2' }}>
              <div className={styles.cameraList}>
                {cameras.map(item => (
                  <div className={styles.cameraContainer}>
                    <img
                      className={
                        activeCamera === item.value
                          ? styles.activeCameraThumb
                          : styles.cameraThumb
                      }
                      src={item.thumbnail}
                      onClick={e => this.setCamera(item.value)}
                    />
                    <div className={styles.cameraHeader}> {item.value} </div>
                  </div>
                ))}
                <div className={styles.cameraContainer} ref="playerP" />
              </div>
              {/* <div>
                <Button
                  text="Move Models"
                  white={streamingMode !== 'move'}
                  onClick={e => this.changeStreamingMode('move')}
                />
                <Button
                  style={{ marginLeft: 30 }}
                  white={streamingMode !== 'rotate'}
                  text="Rotate Models"
                  onClick={e => this.changeStreamingMode('rotate')}
                />
              </div> */}
            </TabPanel>
            <TabPanel style={{ background: '#f2f2f2' }}>
              <div className={styles.productsConfig}>
                <div className={styles.configItemList}>
                  <h4> Item 1 (Main)</h4>
                  <div className={styles.selectContainer}>
                    <ReactSelect
                      className={styles.select}
                      options={item1.options}
                      value={item1.selected.sceneId}
                      onChange={data => this.changeModelId(data, 'item1')}
                    />
                    <span
                      className={styles.addModel}
                      onClick={e => this.selectModel('item1')}
                    >
                      {' '}
                      Edit{' '}
                    </span>
                  </div>
                  <h4> Item 2</h4>
                  <div className={styles.selectContainer}>
                    <ReactSelect
                      className={styles.select}
                      options={item2.options}
                      value={item2.selected.sceneId}
                      onChange={data => this.changeModelId(data, 'item2')}
                    />
                    <span
                      className={styles.addModel}
                      onClick={e => this.selectModel('item2')}
                    >
                      {' '}
                      Edit{' '}
                    </span>
                  </div>
                  <h4> Item 3</h4>
                  <div className={styles.selectContainer}>
                    <ReactSelect
                      className={styles.select}
                      options={item3.options}
                      value={item3.selected.sceneId}
                      onChange={data => this.changeModelId(data, 'item3')}
                    />
                    <span
                      className={styles.addModel}
                      onClick={e => this.selectModel('item3')}
                    >
                      {' '}
                      Edit{' '}
                    </span>
                  </div>
                </div>
                {selectModel && (
                  <div className={styles.configPannel}>
                    <h4> Select Collection </h4>
                    <ReactSelect
                      autoFocus={true}
                      className={styles.select}
                      options={products.map(item => ({
                        label: item.name,
                        value: item.name.toLowerCase(),
                      }))}
                      value={productSelect}
                      onChange={data => this.loadProduct(data)}
                    />
                    <h4> Select Model </h4>
                    <ReactSelect
                      className={styles.select}
                      options={Object.keys(models).map(key => {
                        const item = models[key];
                        const asset = item.assets.slice(-1).pop();
                        return {
                          label: item.friendlyName,
                          value: asset && asset.claraUuid,
                        };
                      })}
                      value={modelSelect && modelSelect.value}
                      onChange={data => this.setState({ modelSelect: data })}
                    />
                    <div className={styles.addtosceneBtn}>
                      <Button
                        text="Add to scene"
                        onClick={this.addModelToScene}
                      />
                    </div>
                  </div>
                )}
              </div>
            </TabPanel>
            <TabPanel style={{ background: '#f2f2f2' }}>
              <div>
                <div className={styles.itemConfigSelection}>
                  <div
                    className={styles.itemConfigTitle}
                    style={{
                      borderBottom:
                        activeConfig === 'item1' ? '3px solid #000' : 'none',
                    }}
                    onClick={e => this.setState({ activeConfig: 'item1' })}
                  >
                    {' '}
                    Item 1{' '}
                  </div>
                  <div
                    className={styles.itemConfigTitle}
                    style={{
                      borderBottom:
                        activeConfig === 'item2' ? '3px solid #000' : 'none',
                    }}
                    onClick={e => this.setState({ activeConfig: 'item2' })}
                  >
                    {' '}
                    Item 2{' '}
                  </div>
                  <div
                    style={{
                      borderBottom:
                        activeConfig === 'item3' ? '3px solid #000' : 'none',
                    }}
                    className={styles.itemConfigTitle}
                    onClick={e => this.setState({ activeConfig: 'item3' })}
                  >
                    {' '}
                    Item 3{' '}
                  </div>
                </div>
                <div>
                  <ConfigPanel
                    product={activeItem}
                    setProduct={data => this.setProduct(data, activeItem)}
                    updateProduct={data => this.updateProduct(data, activeItem)}
                  />
                </div>
              </div>
            </TabPanel>
            <TabPanel style={{ background: '#f2f2f2' }}>
              <div className={styles.itemList}>
                <div className={styles.renderTitle}>Result Name</div>
                <input
                  className={styles.titleInput}
                  onBlur={e => this.setState({ filename: e.target.value })}
                />
                <div className={styles.renderTitle}>Select Render Quality</div>
                <div className={styles.renderQuality}>
                  {imgQuality.map(item => (
                    <div className={styles.qualityOption}>
                      <Checkbox
                        id={item.value}
                        checked={item.value === quality}
                        onChange={e => this.selectQuality(e, 'quality')}
                      />
                      <div className={styles.imgQuality}>
                        {item.title}{' '}
                        <span className={styles.qualitymodelsNote}>
                          {item.note}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
                <div className={styles.renderBtn}>
                  <Button text="Start Render" onClick={this.savePublished} />
                </div>
                {renderMsg && <p style={{ color: 'green' }}>{renderMsg}</p>}
              </div>
            </TabPanel>
          </Tabs>
        </div>
        <Modal isOpen={showError} style={customStyles}>
          <div className={styles.content}>
            <div className={styles.header}> Connection interrupted </div>
            <div className={styles.text}>The connection is interrupted</div>
            <div className={styles.btnGroup}>
              <Button text="Reconnect" />
              <Button
                text="Exit"
                style={{ marginLeft: 30 }}
                onClick={this.closeModal}
              />
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StreamingPlayer/index.js